import { render, staticRenderFns } from "./couserViewnewPast.vue?vue&type=template&id=0a970d97&scoped=true"
import script from "./couserViewnewPast.vue?vue&type=script&lang=js"
export * from "./couserViewnewPast.vue?vue&type=script&lang=js"
import style0 from "./couserViewnewPast.vue?vue&type=style&index=0&id=0a970d97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a970d97",
  null
  
)

export default component.exports